import { UPDATE_DIALOG_RESET_PASSWORD_ERROR } from './index';

export const updateDialogResetPasswordErrorAction = (reset_password_error) => ({
    type: UPDATE_DIALOG_RESET_PASSWORD_ERROR,
    reset_password_error
});